<template>
  <footer class="app-footer">
    <section class="app-footer__content">

      <!-- Disclaimer -->
      <div class="app-footer__disclaimer">
        <p>
          Copyright © {{ year }} Canada Drives. All rights reserved.
          Canada Drives<sup>®</sup> and the Canada Drives Logo design are
          registered trademarks of Canada Drives Ltd. Other
          trademarks are the property of their respective owners.
        </p>
      </div>

      <!-- Links -->
      <div class="app-footer__links">
        <div
          class="app-footer__links-item"
          v-for="(link, index) in footerLinks"
          :key="index"
          @click="showPopup(link)"
          @keydown.enter="showPopup(link)"
          tabindex="0"
        >
          {{ link.text }}
        </div>
      </div>

      <div class="app-footer__phone">
        <a :href="`tel:${ phoneNumber }`">{{ phoneNumber }}</a>
      </div>
    </section>

    <!-- Iframe Popup -->
    <AppPopupIframe
      :show="popup.show"
      :title="popup.title"
      :url="popup.url"
      @hide="hide"
    />
  </footer>
</template>

<script>
/**
 * <app-footer></app-footer>
 * @desc application footer, with legal page links / popup
 */
import AppPopupIframe from '../popups/AppPopupIframe'

export default {
  // Name
  name: 'app-footer',

  // Components
  components: {
    AppPopupIframe
  },

  // Data
  data () {
    return {
      year: new Date().getFullYear(),
      phoneNumber: '1-888-865-6402',
      lastFocus: undefined,
      popup: {
        show: false,
        title: undefined,
        url: undefined
      },
      footerLinks: [{
        text: 'Privacy Policy',
        url: `${process.env.VUE_APP_SITE_URL}/privacy-policy`
      }, {
        text: 'Legal Agreements',
        url: `${process.env.VUE_APP_SITE_URL}/legal-agreements`
      }, {
        text: 'Website Terms of Use',
        url: `${process.env.VUE_APP_SITE_URL}/website-terms-use`
      }, {
        text: 'Contact',
        url: `${process.env.VUE_APP_SITE_URL}/help-centre`
      }]
    }
  },

  // Methods
  methods: {
    showPopup (link) {
      this.lastFocus = document.activeElement
      this.popup = {
        show: true,
        title: link.text,
        url: link.url
      }
    },

    hide () {
      this.popup.show = false
      if (this.lastFocus) this.lastFocus.focus()
    }
  }
}
</script>

<style scoped lang="scss">
$footer-text-color: #95989A;
$footer-link-color: #808080;
$footer-border-color: #DBDBDB;

.app-footer {
  border-top: 1px solid $footer-border-color;
  background-color: #fff;
  text-align: center;
  padding: 15px;
  font-size: 8px;
  line-height: 1.6;
  overflow: hidden;
  font-size: 14px !important;

  @include breakpoint('tablet-portrait-up') {
    font-size: 14px;
  }

  &__content {
    max-width: 100%;
    margin: auto;
    color: $footer-text-color;
    text-align: center;

    @include breakpoint('tablet-portrait-up') {
      width: 730px;
    }

    @include breakpoint('desktop-up') {
      text-align: center;
      width: 566px;
    }
  }

  &__disclaimer {
    p {
      margin: 20px 0;
    }
  }

  &__email,
  &__link,
  a {
    cursor: pointer;
    color: $footer-link-color;
    text-decoration: none;

    &:hover {
      color: $theme-text-black;
    }
  }

  &__links {
    // width: 400px;
    max-width: 100%;
    text-align: center;
    margin: auto auto 20px auto;

    @include breakpoint('desktop-up') {
      text-align: center;
      font-size: 14px;
    }
  }

  &__links-item {
    position: relative;
    display: inline-block;
    flex-shrink: 1;
    margin-right: 15px;
    cursor: pointer;

    &:hover {
      color: $theme-text-black;
    }

    &:after {
      content: '|';
      display: block;
      position: absolute;
      top: 0;
      right: -10px;
      pointer-events: none;
    }

    &:last-child {
      margin-right: 0;

      &:after {
        display: none;
      }
    }

    &:focus:not(.focus-visible) {
      outline: none;
    }

    &:focus-visible {
      border: 2px solid blue;
    }
  }

  &__phone {
    margin: 20px 0;
    color: $footer-link-color;

    @include breakpoint('desktop-up') {
      display: none;
    }
  }
}
</style>
